module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.96a465b5.png";